/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
$(document).ready(function(){
    /*var $returnTo = $('<input type="hidden" name="return_to" value="/pages/thank-you" />');
  

    if ($('#create_customer').length > 0){ //if registration form
        $returnTo.insertBefore($('#create_customer input[type="submit"]')); // add return_to input
    } else if ($('#g-recaptcha').length){ //if captcha form
        $returnTo.insertBefore($('.shopify-challenge__container input[type="submit"]'));
    }*/
  
  
  // account recover with captcha
  var $returnTo = $('<input type="hidden" name="return_to" value="/pages/reset-password-thank-you" />');
  var $returnToThanks = $('<input type="hidden" name="return_to" value="/pages/thank-you" />');
  $("#challenge form").each(function() {
     if ($(this).attr('action').indexOf("account/recover") != -1  ) {
         $returnTo.insertBefore($('.shopify-challenge__container input[type="submit"]'));
     } /*else if ($(this).attr('action').indexOf("account") != -1) {
         $returnToThanks.insertBefore($('.shopify-challenge__container input[type="submit"]'));
     }*/
  });
  
  
  $('.so-tab h3').each(function() {
    var tis = $(this), state = false, answer = tis.next('div.so-tab-content').slideUp();
    tis.click(function() {
      state = !state;
      answer.slideToggle(state);
      tis.toggleClass('active',state);
    });
  });
  
$('.right_side .product__form-wrapper .product__add-to-cart-button .primary-text').text("One Time Purchase");
  $( ".right_side .product__form-wrapper p" ).first().addClass( "sub_text" );
  var str = "Subscribe and never run out of VSL#3<sup>®</sup>. The plan allows you to subscribe quickly, hassle free and you can cancel, skip or edit anytime. Choose the frequency that best suits you from a 1, 2, or 3 months subscription.";
  $('.right_side .product__form-wrapper .sub_text').html(str);
  
  $( ".rc_header-settings__description p" ).first().addClass( "rc_text" );
  var rc_str ="Please provide the email address used to subscribe to complete your account setup. Once complete, you can manage your subscriptions directly within your account.";
  $('.rc_header-settings__description .rc_text').html(rc_str);

  if ( $('form.cart__form').length > 0 ){
    
  	validateCart(null);    
	$('form.cart__form #checkout-cart-btn').click(function( event ) {
  	  validateCart(event);
//       if ($(".navigation__links li.navigation__link--secondary").first().text().includes('Log in') && subProducts.length > 0 ){       
// 	    window.location.href = "/account/login";
//       }
  	});
  }
  
  $('form.cart__form .cart-item__remove').click(function( event ) {
    setTimeout(validateCart, 1000);
  });
});


var subProducts = [];
var products = [];
function validateCart(subEvent) {
  $("#checkout-cart-btn").removeClass("inactive");
  products = [];
  var haveDuplicateProduct = false;
  
  subProducts = [];
  $('table.cart__table tbody tr.cart-item').each(function() {
    var productId = $(this).data('variant');
    if ( ($(this).find("ul.cart-item__properties li").first().text()).includes('Delivery every') ) {
      subProducts.push(productId);
    }
    haveDuplicateProduct = products.includes(productId);
    products.push(productId);
    
  });
  
  var dupEle = $("#duplicate_alert");
  if (subProducts.length > 1) {
    //Display alert
    if ( subEvent != null ) {
      subEvent.preventDefault();
    }
    dupEle.show();
    $("#checkout-cart-btn").prop("disabled", true);
    $("#checkout-cart-btn").addClass("inactive");
  } else {
    $("#checkout-cart-btn").prop("disabled", false);
    $("#checkout-cart-btn").removeClass("inactive");
    dupEle.hide();
  }
}

 function addItemToCart(variant_id, qty, selling_plan) {

    data = {
      "id": variant_id,
      "quantity": qty,
      "selling_plan": selling_plan
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        window.location.href = '/cart'; 
      }
    });
  }